import {customApi} from "./customSdpApiService";


export const getAllCompanies = async (data)=>{

  try {
    const response = await customApi.get('/get-companies', data);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching the data:", error);
    throw error;
  }
}
